import { CHANNEL_PROOFREAD_CLARITY_FEEDBACK_REASON_ANALYZE_EVENT } from '@chegg-wt/core/constants/pusher'
import { WtPusherEvent } from '@chegg-wt/core/state/paraphraser/types'
import pusherManager from '@chegg-wt/core/utils/paraphraser/pusherManager'
import { clarityFeedbackReasonDataHandler } from '@chegg-wt/core/utils/paraphraser/pusherDataHandlers'
import { ClarityReasonFeedbackArgs } from '../types'

export const handleClarityReasonFeedback = async ({
  paperId,
  sentenceId,
  originalText,
  correctedSentence,
  clarityCardId,
  handleClarityFeedbackReasonData,
  setError,
}: ClarityReasonFeedbackArgs) => {
  try {
    await pusherManager.subscribe(
      CHANNEL_PROOFREAD_CLARITY_FEEDBACK_REASON_ANALYZE_EVENT,
      (eventData: WtPusherEvent) =>
        clarityFeedbackReasonDataHandler.handleClarityFeedbackReasonEvent(
          eventData,
          handleClarityFeedbackReasonData
        )
    )
  } catch {
    setError({ code: 'PUSHER_CONNECTION_ERROR', message: "Couldn't connect to pusher" })
    return
  }

  const traceId = await pusherManager.getTraceId()
  const initiatedAt = new Date().toISOString()

  clarityFeedbackReasonDataHandler.enableClarityFeedbackReason({
    sentenceId,
    originalSentence: { originalText, id: sentenceId },
    initiatedAt,
    traceId,
    paperId,
    correctedSentence,
    clarityCardId,
    setError,
  })

  await clarityFeedbackReasonDataHandler.handleClarityFeedbackReasonCall(
    correctedSentence,
    initiatedAt,
    { originalText, id: sentenceId },
    paperId,
    traceId
  )
}
